import React, { useState } from "react";
import {
  createMessage,
  NO_ACTIVE_SUBSCRIPTION,
  PAID,
} from "ee/constants/messages";
import { useDispatch, useSelector } from "react-redux";
import {
  StyledPageWrapper,
  StyledBannerWrapper,
  StyledCardWrapper,
  StyledContent,
  StyledLinkWrapper,
  StyledCardContent,
  StyledDivider,
  ContactUsButtonContainer,
} from "../styles";
import PageHeader from "pages/common/PageHeader";
import { ASSETS_CDN_URL } from "constants/ThirdPartyConstants";
import { Button, Text } from "@appsmith/ads";
import { getAssetUrl } from "ee/utils/airgapHelpers";
import {
  isDowngradeLicenseModalOpen,
  isLicenseRefreshing,
} from "ee/selectors/organizationSelectors";
import {
  refreshLicenseAndFlags,
  removeLicense,
} from "ee/actions/organizationActions";
import DowngradeModal from "ee/pages/Billing/Components/Modals/DowngradeModal";
import LicenseAddForm from "./LicenseAddForm";
import { useIsCloudBillingEnabled } from "hooks";
import { ContactUsButton } from "ee/pages/Billing/Components/BillingCloud/ContactUsButton";

const LICENSE_CARD_FREE = getAssetUrl(
  `${ASSETS_CDN_URL}/add-license-card-free.svg`,
);

const LICENSE_CARD_PAID = getAssetUrl(
  `${ASSETS_CDN_URL}/add-license-card-paid.svg`,
);

export default function AILicenceExpiredPage() {
  const dispatch = useDispatch();

  const [showLicenseForm, setShowLicenseForm] = useState(false);
  const licenseRefreshing = useSelector(isLicenseRefreshing);
  const isDowngradeModalOpen = useSelector(isDowngradeLicenseModalOpen);
  const isCloudBillingEnabled = useIsCloudBillingEnabled();

  const onUpdateLicenseClick = () => {
    dispatch(removeLicense());
  };

  return (
    <>
      <PageHeader hideEditProfileLink />
      <StyledPageWrapper>
        <StyledBannerWrapper>
          <Text
            data-testid="t--no-active-subscription-text"
            kind="heading-xl"
            renderAs="h1"
          >
            {"Your license has expired"}
          </Text>
        </StyledBannerWrapper>
        <div className="flex mt-8">
          <StyledCardWrapper
            className="border-right-1"
            data-testid="t--license-check-card-wrapper-contact"
          >
            <StyledCardContent>
              <img
                alt={createMessage(NO_ACTIVE_SUBSCRIPTION)}
                className="!h-60"
                loading="lazy"
                src={LICENSE_CARD_FREE}
              />
              <Text kind="heading-m" renderAs="p">
                {"Need more time?"}
              </Text>
              <Text kind="body-m" renderAs="p">
                {"Have a valid use case? Reach out to request an extension."}
              </Text>
              <ContactUsButtonContainer>
                <ContactUsButton sourcePage="license-expired" />
              </ContactUsButtonContainer>
            </StyledCardContent>
          </StyledCardWrapper>
          <StyledDivider orientation="vertical" />
          <StyledCardWrapper data-testid="t--license-check-card-wrapper-paid">
            <StyledCardContent>
              <img
                alt={createMessage(NO_ACTIVE_SUBSCRIPTION)}
                className="!h-60"
                loading="lazy"
                src={LICENSE_CARD_PAID}
              />
              <Text kind="heading-m" renderAs="p">
                {createMessage(PAID)}
              </Text>
              <Text kind="body-m" renderAs="p">
                {"Upgrade to continue using AI features."}
              </Text>
              <LicenseAddForm
                setShowLicenseForm={setShowLicenseForm}
                showLicenseForm={showLicenseForm}
              />
            </StyledCardContent>

            {!isCloudBillingEnabled && (
              <StyledLinkWrapper>
                <StyledContent data-testid="t--get-license-key-label">
                  {"Already upgraded?"}
                </StyledContent>
                <Button
                  isLoading={licenseRefreshing}
                  kind="secondary"
                  onClick={() => dispatch(refreshLicenseAndFlags())}
                  size="sm"
                  startIcon="refresh"
                >
                  {"Refresh"}
                </Button>
              </StyledLinkWrapper>
            )}
          </StyledCardWrapper>
        </div>
      </StyledPageWrapper>
      <DowngradeModal
        isExpired
        isOpen={isDowngradeModalOpen}
        onUpdateLicenseClick={onUpdateLicenseClick}
      />
    </>
  );
}
